export const MAX_LISTING_IMAGES = 7;

export const LISTING_IMAGE_MIME_TYPES = ["image/jpeg", "image/png", "image/jpg"] as const;

export const LISTING_IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png"] as const;

export const LISTING_IMAGE_ACCEPT = [
  ...LISTING_IMAGE_EXTENSIONS,
  ...LISTING_IMAGE_MIME_TYPES,
].join(",");

export const toServerImageKey = (id: number) => `server:${id}`;

export const toPendingImageKey = (key: string) => `pending:${key}`;

export const canAddListingImage = (currentCount: number) =>
  currentCount < MAX_LISTING_IMAGES;

export const getListingImageUploadBlockMessage = (
  currentCount: number,
  hasFile: boolean,
): string | null => {
  if (!hasFile) return null;
  if (!canAddListingImage(currentCount)) {
    return `Maximum ${MAX_LISTING_IMAGES} images allowed`;
  }
  return null;
};

export const reorderKeys = (order: string[], fromIndex: number, toIndex: number): string[] => {
  if (fromIndex === toIndex || fromIndex < 0 || toIndex < 0) return order;
  const next = [...order];
  const [moved] = next.splice(fromIndex, 1);
  if (moved === undefined) return order;
  next.splice(toIndex, 0, moved);
  return next;
};

/** Resolve imageOrder keys to document IDs after pending uploads are mapped. */
export const resolveOrderedImageIds = (
  order: string[],
  pendingIdByKey: Record<string, number> = {},
): number[] => {
  const ids: number[] = [];
  for (const key of order) {
    if (key.startsWith("server:")) {
      const id = Number(key.slice("server:".length));
      if (Number.isFinite(id) && id > 0) ids.push(id);
      continue;
    }
    if (key.startsWith("pending:")) {
      const pendingKey = key.slice("pending:".length);
      const id = pendingIdByKey[pendingKey];
      if (typeof id === "number" && id > 0) ids.push(id);
    }
  }
  return ids;
};

export const DESCRIPTION_REQUIRED_MESSAGE = "Description is required";

/** Quill empty HTML (`""`, `<p><br></p>`, etc.) should fail required checks. */
export const isQuillContentEmpty = (html?: string | null): boolean => {
  if (!html) return true;
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();
  return text.length === 0;
};
